import React from 'react';
import Hero from '../../components/Hero';
import About from '../../components/About';
import Features from '../../components/Features';
import Stats from '../../components/Stats';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Features />
      <Stats />
    </>
  );
};

export default Home;

